import { toast } from "sonner";
import { parseErrors } from "./parse";
import { toastError } from "lib/toast";

export const handleThrottle = (response) => {
  const errors = parseErrors(response);

  if (response.status !== 429){
    return false;
  }

  const retryAfter = response.data.retry_after;
  
  const waitTime = retryAfter < 60 ?
    `${retryAfter}초` :
    `${Math.trunc(retryAfter / 60)}분 ${retryAfter % 60}초`;
  
  toastError(`${errors[0].message} ${waitTime} 뒤에 다시 시도해 주세요.`);

  return true;
}